import { DEFAULT_VALIDATION_MESSAGE_TYPE as e, VALIDATION_MESSAGE_TYPES as t } from "../constants/index.js";
import { Comment as n, Text as r, h as i } from "vue";
//#region common/utils/index.js
var a = 0, o, s = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]", c = typeof setImmediate == "function" ? setImmediate : setTimeout;
function l(e = "dt") {
	return `${e}${a++}`;
}
function u(e, t) {
	if (t) {
		let n = d(t);
		return e[Math.abs(n) % e.length];
	} else return e[f(e.length)];
}
function d(e) {
	let t;
	for (let n = 0; n < e.length; n++) t = Math.imul(31, t) + e.charCodeAt(n) | 0;
	return t;
}
function f(e) {
	return Math.floor(Math.random() * e);
}
function p(t) {
	return t ? t.map((t) => typeof t == "string" ? {
		message: t,
		type: e
	} : t) : [];
}
function m(e) {
	let t = h(e);
	return !e || !t ? [] : e.filter((e) => !!e.message && e.type === t);
}
function h(e) {
	return e ? g(e, t.CRITICAL) ? t.CRITICAL : g(e, t.WARNING) ? t.WARNING : g(e, t.POSITIVE) ? t.POSITIVE : null : null;
}
function g(e, t) {
	return !e || !t ? !1 : e.some((e) => e?.type === t);
}
function _(e) {
	return e?.querySelector(s);
}
var v = (e) => i("div", { innerHTML: e.html }), y = () => new Promise((e) => {
	c(e);
});
function b(e, t = {}) {
	return e ? e(t).some((e) => e.type === n || Array.isArray(e.children) && !e.children.length ? !1 : e.type !== r || typeof e.children == "string" && e.children.trim() !== "") : !1;
}
var x = (e) => e?.toLowerCase().split("-").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(""), S = (e) => e.replace(/\.?([A-Z0-9]+)/g, (e, t) => "-" + t.toLowerCase()).replace(/^-/, ""), C = (e) => {
	let t = Object.entries(e).filter(([e]) => e.match(/on[A-Z]/));
	return Object.fromEntries(t);
}, w = (e) => {
	let t = Object.entries(e).filter(([e]) => !e.match(/on[A-Z]/));
	return Object.fromEntries(t);
}, T = (e) => e?.nodeType === Node.ELEMENT_NODE ? e : e?.nodeType ? T(e?.nextSibling) : null;
function E(e) {
	let t = Object.entries(e).filter(([e]) => !["class", "style"].includes(e));
	return Object.fromEntries(t);
}
function D(e, t = 300) {
	clearTimeout(o), o = setTimeout(e, t);
}
function O(e) {
	let t = e.getBoundingClientRect(), n = {
		top: t.top < 0,
		left: t.left < 0,
		bottom: t.bottom > (window.innerHeight || document.documentElement.clientHeight),
		right: t.right > (window.innerWidth || document.documentElement.clientWidth)
	};
	return n.any = Object.values(n).some((e) => e), n.all = Object.values(n).every((e) => e), n;
}
var k = /(?:(?:[^\s!@#$%^&*()_=+[\]{}\\|;:'",.<>/?]+)\.)/, A = /* @__PURE__ */ RegExp("(?:com|ru|org|net|de|jp|uk|br|it|pl|fr|in|au|ir|info|nl|cn|es|cz|kr|ca|eu|ua|co|gr|za|ro|biz|ch|se|tw|mx|vn|hu|be|tr|at|dk|tv|me|ar|sk|no|us|fi|id|cl|xyz|io|pt|by|il|ie|nz|kz|hk|lt|cc|my|sg|club|bg|edu|рф|pk|su|top|th|hr|rs|pe|pro|si|az|lv|pw|ae|ph|online|ng|ee|ws|ve|cat)"), j = /* @__PURE__ */ RegExp("(?:(?:[0-9]|[1-9]\\d|1\\d{2}|2[0-4]\\d|25[0-5])\\.){3}(?:[0-9]|[1-9]\\d|1\\d{2}|2[0-4]\\d|25[0-5])"), M = RegExp("(?:" + [[k.source, A.source].join("+"), j.source].join("|") + ")"), N = /(?:(?:[;/][^#?<>\s]*)?)/, P = /(?:(?:\?[^#<>\s]+)?(?:#[^<>\s]+)?)/, F = RegExp("\\b" + [
	M.source,
	N.source,
	P.source,
	"(?!\\w)"
].join("+")), I = /\b[a-z\d.-]+:\/\/[^<>\s]+/, L = RegExp("(?:mailto:)?[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@" + [M.source, P.source].join("+") + "(?!\\w)");
function R(e = 7, t = 15) {
	try {
		return RegExp(`(?:^|(?<=\\W))(?![\\s\\-])\\+?(?:[0-9()\\- \\t]{${e},${t}})(?=\\b)(?=\\W(?=\\W|\$)|\\s|\$)`);
	} catch {
		console.warn("This browser doesn't support regex lookahead/lookbehind");
	}
	return RegExp(`(?![\\s\\-])\\+?(?:[0-9()\\- \\t]{${e},${t}})(?=\\b)(?=\\W(?=\\W|\$)|\\s|\$)`);
}
var z = R(), B = new RegExp([
	F.source,
	I.source,
	L.source,
	z.source
].join("|"), "gi");
function V(e) {
	return !e || !["string", "number"].includes(typeof e) ? !1 : (e = e.toString(), z.exec(e)?.[0] === e);
}
function H(e) {
	return !e || typeof e != "string" ? !1 : F.exec(e)?.[0] === e || I.exec(e)?.[0] === e;
}
function U(e) {
	return !e || typeof e != "string" ? !1 : L.exec(e)?.[0] === e;
}
function W(e) {
	return e.filter((e) => !!e).join(", ");
}
function G(e, t = "en-US") {
	return e.replace(/^\p{CWU}/u, (e) => e.toLocaleUpperCase(t));
}
function K(e, t) {
	typeof process > "u" || process.env.NODE_ENV === "test" && (!e || !(e instanceof HTMLElement) || !document?.body || document.body.contains(e) || console.warn(`The ${t} component is not attached to the document body. This may cause issues.`));
}
function q(e = document.documentElement) {
	return !!e.hasAttribute("data-overlayscrollbars");
}
function J(e = document.documentElement) {
	q(e) ? e.classList.add("d-scrollbar-disabled") : e.classList.add("d-of-hidden");
}
function Y(e = document.documentElement) {
	q(e) ? e.classList.remove("d-scrollbar-disabled") : e.classList.remove("d-of-hidden");
}
function X(e) {
	return e.replaceAll(/[ -]/g, "_").replaceAll(/\W/g, "").toUpperCase();
}
var Z = {
	getUniqueString: l,
	getRandomElement: u,
	getRandomInt: f,
	formatMessages: p,
	filterFormattedMessages: m,
	hasFormattedMessageOfType: g,
	getValidationState: h,
	htmlFragment: v,
	flushPromises: y,
	kebabCaseToPascalCase: x,
	extractVueListeners: C,
	extractNonListeners: w,
	removeClassStyleAttrs: E,
	returnFirstEl: T,
	debounce: D,
	isOutOfViewPort: O,
	getPhoneNumberRegex: R,
	linkRegex: B,
	isEmailAddress: U,
	isPhoneNumber: V,
	isURL: H,
	safeConcatStrings: W,
	capitalizeFirstLetter: G,
	disableRootScrolling: J,
	enableRootScrolling: Y
};
//#endregion
export { G as capitalizeFirstLetter, D as debounce, Z as default, J as disableRootScrolling, Y as enableRootScrolling, w as extractNonListeners, C as extractVueListeners, m as filterFormattedMessages, _ as findFirstFocusableNode, y as flushPromises, p as formatMessages, R as getPhoneNumberRegex, u as getRandomElement, f as getRandomInt, l as getUniqueString, h as getValidationState, g as hasFormattedMessageOfType, b as hasSlotContent, v as htmlFragment, U as isEmailAddress, O as isOutOfViewPort, V as isPhoneNumber, H as isURL, d as javaHashCode, x as kebabCaseToPascalCase, B as linkRegex, S as pascalCaseToKebabCase, E as removeClassStyleAttrs, T as returnFirstEl, W as safeConcatStrings, X as toFluentKeyString, K as warnIfUnmounted };

//# sourceMappingURL=index.js.map